import { jsxs, jsx } from "react/jsx-runtime";
import { Icon } from "../MainIcon/MainIcon.js";
import "@mui/material";
const DEFAULT_VIEWBOX = "0 0 24 24";
const CallCompanyIcon = ({ size, viewBox = DEFAULT_VIEWBOX, ...rest }) => {
  return /* @__PURE__ */ jsxs(Icon, { size, ...rest, viewBox, children: [
    /* @__PURE__ */ jsx("rect", { width: "24", height: "20", rx: "4", fill: "#EDF8F7" }),
    /* @__PURE__ */ jsx("rect", { x: "4", y: "2", width: "16", height: "16", rx: "8", fill: "#EDF8F7" }),
    /* @__PURE__ */ jsx(
      "path",
      {
        d: "M7.3594 4C6.60607 4 5.9794 4.62687 6.02607 5.38021C6.20274 8.22621 7.42898 10.7857 9.32164 12.6784C11.2143 14.5711 13.7738 15.7973 16.6198 15.974C17.3732 16.0206 18 15.394 18 14.6406V13.487C18 12.807 17.4937 12.2402 16.8203 12.1602L15.1407 11.9661C14.734 11.9195 14.3336 12.0597 14.0469 12.3464L12.8138 13.5794C11.8678 13.0994 11.0096 12.4738 10.2683 11.7318C9.52626 10.9904 8.9006 10.1322 8.4206 9.1862L9.65367 7.95312C9.94034 7.66646 10.0805 7.26604 10.0339 6.85937L9.83987 5.17969C9.75987 4.50635 9.19305 4 8.51305 4H7.3594ZM12.6667 4C12.3 4 12 4.3 12 4.66667V9.67057C12 9.96324 12.3539 10.1103 12.5612 9.90365L13.7969 8.66667H17.3334C17.7 8.66667 18 8.36667 18 8V4.66667C18 4.3 17.7 4 17.3334 4H12.6667Z",
        fill: "#00624F"
      }
    )
  ] });
};
export {
  CallCompanyIcon
};
